import React from 'react'
import findImageFormat from '../../helpers/findImageFormat';

const CarJSONLD = ({car}) => {
    // Read featured image based on var type.
    let featuredImage = '';
    if(car.featuredImage) {
        if (typeof car.featuredImage === 'string') {
            featuredImage = car.featuredImage;
        } else if (typeof car.featuredImage === 'object') {
            featuredImage = findImageFormat(car.featuredImage, '800x')[0].src;
        }
    }


    const json = {
        '@context': 'https://schema.org/',
        '@type': 'Vehicle',
        bodyType: car.properties.chassis,
        fuelType: car.fuelType,
        mileageFromOdometer: { value: car.mileage, unitText: 'mil'},
        driveWheelConfiguration: car.properties.drivingWheel,
        vehicleTransmission: car.gearboxType,
        manufacturer: car.manufacturer,
        brand: car.manufacturer,
        model: car.modelSeries,
        color: car.properties.colorName,
        modelDate: car.year,
        name: car.title + ' ' + car.shortDescription,
        description: car?.description ?? car.shortDescription,
        image: featuredImage,
        sku: 1,
        offers: { price: car.price, priceCurrency:'SEK', availability: 'https://schema.org/InStock' }
    }

    const createMarkup = ()=>{
        return { __html: JSON.stringify(json) };
    }

    return (
        <script type="application/ld+json" dangerouslySetInnerHTML={createMarkup()}></script>
    )
}


export default CarJSONLD